import type { ReactNode } from 'react';
import { Button } from '@radix-ui/themes';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

export const Container: React.FC<{
  title: string;
  children: ReactNode;
  className?: string;
  buttonTitle?: string;
  buttonLink?: string;
  contentClassName?: string;
}> = ({ title, children, className, buttonTitle, buttonLink, contentClassName }) => (
  <div
    id='container'
    className={`border-neutral-neutral-2 flex flex-col items-start gap-2 self-stretch rounded-2xl border border-solid p-3 bg-neutral-neutral-1${className ? ` ${className}` : ''}`}
  >
    <div id='topbar' className='flex justify-between gap-2 self-stretch'>
      <div className='text-neutral-neutral-12 self-stretch text-lg font-medium tracking-tight'>{title}</div>
      {buttonTitle && buttonLink && (
        <Link to={buttonLink}>
          <Button className='cursor-pointer' variant='outline'>
            {buttonTitle}
          </Button>
        </Link>
      )}
    </div>
    <div
      id='content'
      className={classNames(
        'text-neutral-neutral-12 flex-1 items-center justify-between self-stretch text-sm font-normal',
        contentClassName,
      )}
    >
      {children}
    </div>
  </div>
);

export default Container;
